module.exports = __webpack_public_path__ + "static/media/img10.c18ef9f7.jpg";